import { GetterTree } from "vuex";
import { IDocumentHistoryState } from "@/store/modules/documentHistory/state";
import DocumentHistory from "@/types/documents/document/DocumentHistory";
import { IDataProvider, IRootState } from "@/store";

export enum DocumentHistoryGetters {
  GET_ALL = "GET_ALL_DOCUMENT_HISTORY",
  GET_CURRENT = "GET_CURRENT_DOCUMENT_HISTORY",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_DOCUMENT_HISTORY",
}

export const getters: GetterTree<IDocumentHistoryState, IRootState> = {
  [DocumentHistoryGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<DocumentHistory> | null {
    return state.dataProvider;
  },
};
